import * as manifest from "./manifest.js";
import { start } from "merlyn/runtime";

document.title = manifest.title || "Merlyn";
start(manifest);
